import { Injectable } from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class StatusMigracaoService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Ação de Relacionamento por id
     * @param id ID da Ação de Relacionamento
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "status-migracao/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Ação de Relacionamento
     * @param id ID da Ação de Relacionamento
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "status-migracao"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Ação de Relacionamento
     * @param id ID da Ação de Relacionamento
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "status-migracao/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "status-migracao", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Ação de Relacionamento
     * @param params Json Ação de Relacionamento
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "status-migracao/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }
}
